import { useEffect, useState } from "react";
import {
  checkWechatLoginStatus,
  getWechatLoginQrcode,
  registerWechatLogin,
} from "../../api";
import { LOGIN_SUCCESS } from "../../constants";
import { isEmpty } from "../../utils";

let checkTimer: NodeJS.Timeout;

const useWechatLogin = () => {
  const [qrcode, setQrcode] = useState("");
  const [token, setToken] = useState("");
  useEffect(() => {
    if (isEmpty(token)) {
      return;
    }
    const check = () => {
      checkWechatLoginStatus(token).then(({ status }) => {
        if (status !== 10) {
          checkTimer = setTimeout(check, 1000);
        } else {
          registerWechatLogin(token).then(({ errcode }) => {
            if (errcode === 0) {
              // 登陆成功
              // const url = new URL(window.location.href);
              // window.location.href = decodeURIComponent(
              //   url.searchParams.get("redirect_url")
              // );
              window.dispatchEvent(new Event(LOGIN_SUCCESS));
            }
          });
        }
      });
    };
    check();

    return () => {
      clearTimeout(checkTimer);
    };
  }, [token]);
  useEffect(() => {
    getWechatLoginQrcode().then((data) => {
      setQrcode(data.qr_code_url);
      setToken(data.token);
    });
  }, []);
  return { qrcode };
};

export default useWechatLogin;
